import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import type { Message } from '@ag-ui/client';
import { setAIV2Messages } from '../../store/actions/ai-v2.actions';

interface PandaChatPersistenceState {
  aiV2: { messages: Message[] };
}

export interface PandaChatPersistence {
  /** History persisted by the host, seeds a freshly-mounted provider. */
  committedMessages: Message[];
  persistMessages: (messages: Message[]) => void;
}

/**
 * Message persistence for hosts that mirror the conversation into the store
 * (web wires it into the provider's `initialMessages`/`onRunSettled`; mobile
 * keeps messages only inside the agent and never calls this).
 */
export function usePandaChatPersistence(): PandaChatPersistence {
  const dispatch = useDispatch();

  const committedMessages = useSelector(
    (state: PandaChatPersistenceState): Message[] => state.aiV2.messages,
  );
  const persistMessages = useCallback(
    (messages: Message[]) => dispatch(setAIV2Messages(messages)),
    [dispatch],
  );

  return { committedMessages, persistMessages };
}
